import { api } from './api';
import type { User, CreateUserRequest, UpdateUserRequest, UserFilter, ApiResponse, PagedResult } from '@/types';

export const userService = {
  getAll: async (filter?: UserFilter): Promise<ApiResponse<PagedResult<User>>> => {
    const params = new URLSearchParams();
    if (filter?.pageNumber) params.append('pageNumber', filter.pageNumber.toString());
    if (filter?.pageSize) params.append('pageSize', filter.pageSize.toString());
    if (filter?.roleId) params.append('roleId', filter.roleId.toString());
    if (filter?.branchId) params.append('branchId', filter.branchId.toString());
    if (filter?.search) params.append('search', filter.search);
    if (filter?.isActive !== undefined) params.append('isActive', filter.isActive.toString());
    const response = await api.get(`/users?${params.toString()}`);
    return response.data;
  },
  getById: async (id: number): Promise<ApiResponse<User>> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },
  create: async (data: CreateUserRequest & { accountType?: string; name?: string; phone?: string }): Promise<ApiResponse<User>> => {
    const roleId = (data as any).roleId || '';
    const accountType = (data as any).accountType || (roleId.startsWith('delegate') ? 'delegate' : roleId.startsWith('merchant') ? 'merchant' : 'staff');
    const payload = {
      name: (data as any).name || (data as any).fullName,
      email: data.email,
      password: data.password,
      phone: (data as any).phone || (data as any).phoneNumber,
      address: (data as any).address,
      roleId,
      branchId: (data as any).branchId ?? null,
      isActive: (data as any).isActive !== false,
      accountType
    };
    const response = await api.post('/users/managed', payload);
    return response.data;
  },
  update: async (id: string, data: UpdateUserRequest): Promise<ApiResponse<User>> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  updateProfile: async (data: {
    fullName?: string;
    email?: string;
    phone?: string;
    address?: string;
    currentPassword?: string;
    newPassword?: string;
  }): Promise<ApiResponse<any>> => {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<boolean>> => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

};
